import React from 'react';
import { Modal, Button, Card, Row, Col, ListGroup, Badge, Table, Spinner, Alert } from 'react-bootstrap';
import { FaFileInvoice, FaUtensils, FaUser, FaRupeeSign } from 'react-icons/fa';
import { colors } from '../../../../../utils/Colors';

const PreviewModal = ({
  show,
  onHide,
  formData,
  formatCurrency,
  calculateFoodBill,
  calculatePerHead,
  calculateGovtTax,
  calculateTotalAmount,
  calculateRemainingAmount,
  handleSubmit,
  loading
}) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton className="text-white" style={{ backgroundColor: colors.TABLE_HEADERS }}>
        <Modal.Title>
          <FaFileInvoice className="me-2" />
          Bill Preview
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Card className="border-0 shadow">
          <Card.Body>
            <div className="text-center mb-4">
              <h3 className="fw-bold" style={{ color: colors.TABLE_HEADERS }}>RONAQ MARQUEE</h3>
              <h5 className="text-muted">EVENT DETAILS</h5>
            </div>

            <Row className="mb-3">
              <Col md={6}>
                <ListGroup variant="flush">
                  <ListGroup.Item className="d-flex justify-content-between">
                    <span className="fw-bold">Name:</span>
                    <span>{formData.eventDetails.name || 'N/A'}</span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex justify-content-between">
                    <span className="fw-bold">CNIC:</span>
                    <span>{formData.eventDetails.cnic || 'N/A'}</span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex justify-content-between">
                    <span className="fw-bold">Date:</span>
                    <span>{formData.eventDetails.dateOfEvent || 'N/A'}</span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex justify-content-between">
                    <span className="fw-bold">Day:</span>
                    <span>{formData.eventDetails.dayOfEvent || 'N/A'}</span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex justify-content-between">
                    <span className="fw-bold">Ladies:</span>
                    <span>{formData.eventDetails.ladies || '0'}</span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex justify-content-between">
                    <span className="fw-bold">Gents:</span>
                    <span>{formData.eventDetails.gents || '0'}</span>
                  </ListGroup.Item>
                </ListGroup>
              </Col>
              <Col md={6}>
                <ListGroup variant="flush">
                  <ListGroup.Item className="d-flex justify-content-between">
                    <span className="fw-bold">Venue:</span>
                    <span>{formData.eventDetails.venue || 'N/A'}</span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex justify-content-between">
                    <span className="fw-bold">Mobile 1:</span>
                    <span>{formData.eventDetails.mob1 || 'N/A'}</span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex justify-content-between">
                    <span className="fw-bold">Mobile 2:</span>
                    <span>{formData.eventDetails.mob2 || 'N/A'}</span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex justify-content-between">
                    <span className="fw-bold">Advance:</span>
                    <span className="text-success">{formatCurrency(formData.eventDetails.advancePayment)}</span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex justify-content-between">
                    <span className="fw-bold">Meal:</span>
                    <span>{formData.eventDetails.lunchDinner || 'N/A'}</span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex justify-content-between">
                    <span className="fw-bold">Persons:</span>
                    <span>{formData.eventDetails.persons || '0'}</span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex justify-content-between">
                    <span className="fw-bold">Per Head:</span>
                    <span className="text-info">{formatCurrency(calculatePerHead())}</span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex justify-content-between">
                    <span className="fw-bold">Service:</span>
                    <Badge bg="primary">{formData.serviceType}</Badge>
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </Row>

            <hr />

            <div className="text-center mb-4">
              <h5 className="fw-bold" style={{ color: colors.TABLE_HEADERS }}>BILL DETAILS</h5>
            </div>

            <Row>
              <Col md={6}>
                <ListGroup variant="flush">
                  {[
                    { label: 'Food Bill', value: calculateFoodBill() },
                    { label: 'DJ/Music', value: formData.billDetails.djMusic },
                    { label: 'Service Charges', value: formData.billDetails.serviceCharges },
                    { label: 'Hall Rent', value: formData.billDetails.hallRent },
                    { label: 'BWD Stage', value: formData.billDetails.bwdStage },
                    { label: 'AC Charges', value: formData.billDetails.acCharges },
                  ].map((item, index) => (
                    <ListGroup.Item key={index} className="d-flex justify-content-between">
                      <span>{item.label}:</span>
                      <span>{formatCurrency(item.value)}</span>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </Col>
              <Col md={6}>
                <ListGroup variant="flush">
                  {[
                    { label: 'Heater Charges', value: formData.billDetails.heaterCharges },
                    { label: 'Ladies Waiter', value: formData.billDetails.ladiesWaiter },
                    { label: 'GOVT tax 5%', value: calculateGovtTax() },
                    { label: 'Other Charges', value: formData.billDetails.otherCharges },
                  ].map((item, index) => (
                    <ListGroup.Item key={index} className="d-flex justify-content-between">
                      <span>{item.label}:</span>
                      <span>{formatCurrency(item.value)}</span>
                    </ListGroup.Item>
                  ))}
                  <ListGroup.Item className="d-flex justify-content-between fw-bold border-top">
                    <span>Total Amount:</span>
                    <span className="text-success">{formatCurrency(calculateTotalAmount())}</span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex justify-content-between fw-bold">
                    <span>Remaining Amount:</span>
                    <span className={calculateRemainingAmount() > 0 ? 'text-danger' : 'text-success'}>
                      {formatCurrency(calculateRemainingAmount())}
                    </span>
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </Row>

            {/* Menu Information */}
            {formData.selectedMainMenu && (
              <Alert variant="info" className="mt-3">
                <FaUtensils className="me-2" />
                <strong>Main Menu Selected:</strong> {formData.selectedMainMenu}
                <div className="mt-1">
                  <FaRupeeSign className="me-1" />
                  <strong>Price:</strong> PKR {formData.mainMenuPrice} per person
                  <span className="ms-3">
                    <FaUser className="me-1" />
                    <strong>For {formData.eventDetails.persons || 0} persons:</strong> {formatCurrency(calculateFoodBill())}
                  </span>
                </div>
                {formData.mainMenuItems.length > 0 && (
                  <div className="mt-2">
                    <strong>Menu Items:</strong>
                    <ul className="mb-0 mt-1">
                      {formData.mainMenuItems.slice(0, 5).map((item, idx) => (
                        <li key={idx}>{item}</li>
                      ))}
                      {formData.mainMenuItems.length > 5 && (
                        <li>...and {formData.mainMenuItems.length - 5} more items</li>
                      )}
                    </ul>
                  </div>
                )}
              </Alert>
            )}

            {formData.menu.length > 0 && formData.customPerHead && parseFloat(formData.customPerHead) > 0 && (
              <Alert variant="warning" className="mt-3">
                <FaUser className="me-2" />
                <strong>Custom Menu with Per Head:</strong> PKR {formData.customPerHead} per person
                <span className="ms-3">
                  <FaUser className="me-1" />
                  <strong>For {formData.eventDetails.persons || 0} persons:</strong> {formatCurrency(calculateFoodBill())}
                </span>
              </Alert>
            )}

            {(formData.menu.length > 0 || formData.mainMenuItems.length > 0) && (
              <>
                <hr />
                <h6 className="fw-bold mb-3" style={{ color: colors.TABLE_HEADERS }}>MENU ITEMS</h6>
                <Table bordered size="sm">
                  <thead>
                    <tr style={{ backgroundColor: colors.TABLE_HEADERS, color: 'white' }}>
                      <th>Item</th>
                      <th>Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Main Menu Items */}
                    {formData.mainMenuItems.map((item, index) => (
                      <tr key={`main-${index}`}>
                        <td>{item}</td>
                        <td>
                          <Badge bg="info">Main Menu</Badge>
                        </td>
                      </tr>
                    ))}

                    {/* Custom/Individual Items */}
                    {formData.menu.map((item, index) => (
                      <tr key={`custom-${index}`}>
                        <td>{item.item}</td>
                        <td>
                          <Badge bg="secondary">{item.category || 'Custom'}</Badge>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr className="fw-bold">
                      <td colSpan="2">
                        Total Items: {formData.mainMenuItems.length + formData.menu.length}
                      </td>
                    </tr>
                  </tfoot>
                </Table>
              </>
            )}
          </Card.Body>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={loading}
          style={{ backgroundColor: colors.TABLE_HEADERS, borderColor: colors.TABLE_HEADERS }}
        >
          {loading ? <Spinner size="sm" /> : 'Confirm & Create Bill'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PreviewModal;